// extracted by mini-css-extract-plugin
export default {"st0":"fouYPP6Xlyh","st1":"foup8rRAkF7","icon":"fou_wbS3Ktb"};